import { jsx as _jsx } from "react/jsx-runtime";
import { Renderer_SearchResult } from '@app/styles';
import { DBDef_AdvisorSnippet, DBDef_AdvisorWizard, } from '@app/advisor-content-shared';
import { ModuleFE_AdvisorSnippet, ModuleFE_AdvisorWizard, } from '../../_entity.js';
import { EditableDBItemV3 } from '@nu-art/thunderstorm-frontend/index';
import { Page_AdvisorContext } from './Page_AdvisorContext.js';
import { MUSTNeverHappenException } from '@nu-art/ts-common';
import { Editor_AdvisorWizard } from './editors/Editor_AdvisorWizard.js';
import { Editor_AdvisorSnippet } from './editors/Editor_AdvisorSnippet.js';
import { ModuleFE_Tag, ModuleFE_Variable } from '@app/hcs-frontend';
import { RoutePermissions } from '@nu-art/permissions-frontend/index';
import { SearchItemV3_With_ID } from '@app/styles/frontend/modules/search/consts';
const EditorKey_AdvisorContext = 'advisor-context-editor';
export const Route_AdvisorContextEditor = {
    key: EditorKey_AdvisorContext,
    path: 'advisor-context',
    enabled: RoutePermissions(ModuleFE_AdvisorWizard.permissions.ui.Release),
    Component: Page_AdvisorContext,
    modulesToAwait: [ModuleFE_AdvisorWizard, ModuleFE_AdvisorSnippet, ModuleFE_Variable, ModuleFE_Tag],
};
export const SearchableItem_AdvisorWizard = SearchItemV3_With_ID({
    type: DBDef_AdvisorWizard.dbKey,
    entityName: DBDef_AdvisorWizard.entityName,
    module: ModuleFE_AdvisorWizard,
    route: Route_AdvisorContextEditor,
    groupId: ['Advisor-Context'],
    entityLabel: 'Advisor Wizard',
    tags: [],
    mapper: (item) => {
        const stepLabels = item.steps.map(step => step.label);
        return [item.label, ...stepLabels];
    },
    renderer: (item, selected, onClickCallback) => {
        return _jsx(Renderer_SearchResult, { itemId: item._id, itemKey: DBDef_AdvisorWizard.dbKey, itemLabel: item.label, entityLabel: 'Advisor Wizard', hierarchy: 'Advisor Context', selected: selected, onClickCallback: onClickCallback });
    },
    resultRenderer: (id) => {
        const wizard = ModuleFE_AdvisorWizard.cache.unique(id);
        if (!wizard)
            throw new MUSTNeverHappenException(`Could not find an advisor wizard for the given id ${id}`);
        const editable = new EditableDBItemV3(wizard, ModuleFE_AdvisorWizard);
        return _jsx(Editor_AdvisorWizard, { editable: editable });
    }
});
export const SearchableItem_AdvisorSnippet = SearchItemV3_With_ID({
    type: DBDef_AdvisorSnippet.dbKey,
    entityName: DBDef_AdvisorSnippet.entityName,
    module: ModuleFE_AdvisorSnippet,
    route: Route_AdvisorContextEditor,
    groupId: ['Advisor-Context'],
    entityLabel: 'Advisor Snippet',
    tags: [],
    mapper: (item) => {
        return [item.label];
    },
    renderer: (item, selected, onClickCallback) => {
        return _jsx(Renderer_SearchResult, { itemId: item._id, itemKey: DBDef_AdvisorSnippet.dbKey, itemLabel: item.label, entityLabel: 'Advisor Snippet', hierarchy: 'Advisor Context', selected: selected, onClickCallback: onClickCallback });
    },
    resultRenderer: (id) => {
        const snippet = ModuleFE_AdvisorSnippet.cache.unique(id);
        if (!snippet)
            throw new MUSTNeverHappenException(`Could not find an advisor snippet for the given id ${id}`);
        const editable = new EditableDBItemV3(snippet, ModuleFE_AdvisorSnippet);
        return _jsx(Editor_AdvisorSnippet, { editable: editable });
    }
});
export const getAdvisorContextManagerSearchItems = () => [SearchableItem_AdvisorWizard, SearchableItem_AdvisorSnippet];
export const workspaceKey_AdvisorContextEditor = 'workspace__advisor-context-editor';
export const WorkspaceConfig_AdvisorContextEditor = {
    name: workspaceKey_AdvisorContextEditor,
    key: 'horizontalSpace',
    visible: true,
    factor: 1,
    min: -1,
    data: {
        panels: [
            { name: 'LeftPanel', key: 'list', visible: true, factor: 1.5 / 5, min: 450, data: {} },
            { name: 'RightPanel', key: 'editor', visible: true, factor: 3.5 / 5, min: 1100, data: {} },
        ]
    }
};
//# sourceMappingURL=consts.js.map